import { authAPI } from "../../../api/auth";
import { useLocStore } from "../../../localization";
import { LocContext } from "../../../localization/LocContext";
import { useWhoAmI } from "../../../user/useWhoAmI";
import { CustomMenuItem } from "../MenuItems/completeMenuItem";

// VPN/islocal-only: hand the current session's candidate over to the OLD cv
// portal (cvp1). The backend mints a short-lived, single-use one-time-url token
// (cvp2's cookie is meaningless to cvp1, which needs a real CGI session) and we
// hard-redirect to cvp1's autologin.aspx, which consumes it. Only rendered when
// we actually have a candidate + concern to carry over (e.g. while impersonating).
export function useLoginToOldPortalMenuItem(): CustomMenuItem | null {
  const L = useLocStore(LocContext.PROFILE);
  const { whoAmI } = useWhoAmI();

  const candidateId = whoAmI?.idCandidate;
  const concernId = whoAmI?.concernId;

  if (!candidateId || !concernId) return null;

  return {
    label: L.id("c3e8d1a4f062").loc("Logg inn i gammel portal (cvp1)"),
    icon: "pi pi-fw pi-external-link",
    className: "vpn-item",
    onClick: async () => {
      const result = await authAPI.impersonationLoginOldPortal({
        k: concernId.toString(),
        candidateId,
        showSentryDialogOnError: true,
      });

      if (result.ok) {
        window.location.href = result.item;
      }
    },
  };
}
